/** @type {string} */
const offcanvasString = "offcanvas";
export default offcanvasString;
